"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _HttpClient_instances, _HttpClient_axios, _HttpClient_onGoingRequests, _HttpClient_onError;
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpClient = void 0;
const axios_1 = require("axios");
class HttpClient {
    constructor() {
        _HttpClient_instances.add(this);
        _HttpClient_axios.set(this, void 0);
        _HttpClient_onGoingRequests.set(this, void 0);
        __classPrivateFieldSet(this, _HttpClient_axios, axios_1.default.create(), "f");
        __classPrivateFieldGet(this, _HttpClient_axios, "f").defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest';
        __classPrivateFieldGet(this, _HttpClient_axios, "f").defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
        __classPrivateFieldSet(this, _HttpClient_onGoingRequests, new Map(), "f");
    }
    get(url, options = {}) {
        return this.getRaw(url, options).catch(err => __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_onError).call(this, err));
        ;
    }
    getRaw(url, options = {}) {
        const key = options.onGoingKey || `${url}${JSON.stringify(options)}`;
        // Return the request from ongoing, if it exists
        if (__classPrivateFieldGet(this, _HttpClient_onGoingRequests, "f").has(key)) {
            return __classPrivateFieldGet(this, _HttpClient_onGoingRequests, "f").get(key);
        }
        const request = __classPrivateFieldGet(this, _HttpClient_axios, "f").get(url, options);
        // Remove the requests from ongoing after it finishes
        request.finally(() => __classPrivateFieldGet(this, _HttpClient_onGoingRequests, "f").delete(key));
        // Store the request in ongoing
        __classPrivateFieldGet(this, _HttpClient_onGoingRequests, "f").set(key, request);
        return request;
    }
    post(url, data) {
        return this.postRaw(url, data).catch(err => __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_onError).call(this, err));
    }
    postRaw(url, data) {
        return __classPrivateFieldGet(this, _HttpClient_axios, "f").post(url, data);
    }
    delete(url, params) {
        return this.deleteRaw(url, params).catch(err => __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_onError).call(this, err));
    }
    deleteRaw(url, params) {
        return __classPrivateFieldGet(this, _HttpClient_axios, "f").delete(url, params);
    }
}
_HttpClient_axios = new WeakMap(), _HttpClient_onGoingRequests = new WeakMap(), _HttpClient_instances = new WeakSet(), _HttpClient_onError = function _HttpClient_onError(error) {
    const container = document.createElement('div');
    container.className = 'notifications-container';
    document.body.appendChild(container);
    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'notifications-close-button';
    closeButton.ariaLabel = 'Close';
    // see https://icons.getbootstrap.com/icons/x/
    closeButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/></svg>';
    closeButton.addEventListener('click', () => container.remove());
    container.appendChild(closeButton);
    const message = document.createElement('div');
    message.className = 'notifications-error';
    message.innerHTML = `<strong>Oops! Something went wrong.</strong><br>Please try again in a moment. If the problem persists, don't hesitate to <a href="https://veello.com/contact" target="_blank">contact our support team</a> — we're here to help.`;
    container.appendChild(message);
    // Log the error in console anyway
    console.error(error);
    // Keep rejection so callers can handle too
    throw error;
};
exports.httpClient = new HttpClient();
